<p-drawer
  #sidebarRef
  [visible]="true"
  [closeOnEscape]="false"
  [showCloseIcon]="false"
  [modal]="false"
  [ngClass]="{ 'small-drawer': isCollapsed() }">
  <ng-template pTemplate="headless">
    <div class="sidebar_sc" [ngClass]="{ collapsed: isCollapsed() }">
      <ul class="sidebar_menu">
        <li *ngFor="let menuItem of menuItems()">
          <a
            [routerLink]="menuItem.link"
            routerLinkActive="active"
            pTooltip="{{ menuItem.tooltip | translate }}">
            <!-- <a *ngIf="!menuItem.submenu" [routerLink]="menuItem.link" routerLinkActive="active"> -->
            <figure>
              <img [src]="[menuItem.icon]" [alt]="menuItem.label" />
            </figure>
            <span>{{ menuItem.label | translate }}</span>
          </a>

          <!-- Menu Items with Submenu -->
          <!-- <a *ngIf="menuItem.submenu" (click)="toggleSubmenu(menuItem)" pRipple>
            <figure>
              <img [src]="[menuItem.icon]" [alt]="menuItem.label" />
            </figure>
            <span>{{ menuItem.label }}</span>
            <i class="pi pi-chevron-down ml-auto" [ngClass]="{'rotate-180': menuItem.isOpen}"></i>
          </a> -->

          <!-- <ul class="submenu" [ngClass]="{'hidden': !menuItem.isOpen}">
            <li *ngFor="let subItem of menuItem.submenu">
              <a [routerLink]="subItem.link" routerLinkActive="active">
                <figure>
                  <img [src]="[subItem.icon]" [alt]="subItem.label" />
                </figure>
                <span>{{ subItem.label }}</span>
              </a>
            </li>
          </ul> -->
        </li>

        <!-- Logout Section -->
        <li class="logout_li">
          <a
            role="button"
            tabindex="0"
            (click)="btn_logOut()"
            (keydown.enter)="btn_logOut()"
            (keydown.space)="btn_logOut()"
            pTooltip="Logout">
            <figure>
              <img [src]="assetsConst.logout" alt="Logout Icon" />
            </figure>
            <span class="font-bold">{{"Logout" | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </ng-template>
</p-drawer>
